import { render } from "./ChallengeParticipations.vue?vue&type=template&id=ca3fb070"
import script from "./ChallengeParticipations.vue?vue&type=script&lang=js"
export * from "./ChallengeParticipations.vue?vue&type=script&lang=js"
script.render = render

export default script